export default __webpack_public_path__ + "static/media/mpa.4b8a998f.svg";